import { defineStore } from "pinia";
import { reactive, ref } from "vue";
import { userStore } from "./user"
import _ from "lodash"

export const frequentlyStore = defineStore('frequentlyUse', () => {
    const data = reactive({});

    // 去重+截取(超50个)
    function uniqWith(key, name) {
        data[key][name] = _.uniqWith(data[key][name], _.isEqual);
        data[key][name].length > 50 ? data[key][name] = data[key][name].splice(0, 50) : null
    }

    const readInfo = (name) => {
        const { getUserInfo } = userStore();
        const { userId, sectionId, tenantId } = getUserInfo();
        const key = `${userId}_${sectionId}_${tenantId}`;
        return data?.[key]?.[name] ?? []
    }
    const addInfo = (name, val) => {
        const { getUserInfo } = userStore();
        const { userId, sectionId, tenantId } = getUserInfo();
        const key = `${userId}_${sectionId}_${tenantId}`;
        data[key] = data[key] ? data[key] : {}
        !data[key][name] ? data[key][name] = [] : null
        data[key][name].unshift(val);
        // 去重
        uniqWith(key, name)
    }
    const replaceInfo = (name, list) => {
        const { getUserInfo } = userStore();
        const { userId, sectionId, tenantId } = getUserInfo();
        const key = `${userId}_${sectionId}_${tenantId}`;
        data[key] = data[key] ? data[key] : {}
        data[key][name] = list;
        uniqWith(key, name)
    }
    return {
        data,
        readInfo,
        addInfo,
        replaceInfo
    }
}, {
    persist: true
})